import {POST} from "@/utils/request/request";
import {commCode} from "@/consts";
// import {POST} from "@/services/Api";

export function ListPlant(data) {
    return POST(commCode.Plant.ListPlant, data)
}
export function CreatePlant(data) {
    return POST(commCode.Plant.CreatePlant, data)
}
export function DeletePlant(data) {
    return POST(commCode.Plant.DeletePlant, data)
}
export function UpdatePlant(data) {
    return POST(commCode.Plant.UpdatePlant, data)
}
export function SinglePlant(data) {
    return POST(commCode.Plant.SinglePlant, data)
}
export function TopUpPlant(data) {
    return POST(commCode.Plant.TopUpPlant, data)
}
export function ChgStatusPlant(data) {
    return POST(commCode.Plant.ChgStatusPlant, data)
}
